import { useEffect } from 'react';
import { SessionViewProps } from '../../container';

type UseResetSessionActiveTab = {
  setSessionActiveTab: SessionViewProps['setSessionActiveTab'];
};

export const useResetSessionActiveTab = ({
  setSessionActiveTab,
}: UseResetSessionActiveTab): void => {
  useEffect(() => {
    return () => {
      setSessionActiveTab('topology');
    };
  }, [setSessionActiveTab]);
};
